import { FileDownload } from '@mui/icons-material';
import { CreatorsListUser } from 'lib/types/users';
import { NETWORK_IDS } from 'lib/constants';

interface Props {
  creators: CreatorsListUser[];
}

export const CreatorsCSVExport = ({ creators }: Props) => {
  const exportToCSV = () => {
    if (!creators || creators.length === 0) return;

    const csvData = creators.map((creator) => {
      // Get Instagram and Twitter accounts from postingAccounts
      const instagramAccount = creator.postingAccounts?.find(
        (account) => account.network === NETWORK_IDS.instagram && account.type === 'owner',
      )?.account || '';

      const twitterAccount = creator.postingAccounts?.find(
        (account) => account.network === NETWORK_IDS.twitter && account.type === 'owner',
      )?.account || '';

      // Get total followers from all owner posting accounts
      const totalFollowers = creator.postingAccounts
        ?.filter((account) => account.type === 'owner')
        ?.reduce((total, account) => total + (account.networkAccount?.followersCount || 0), 0) || 0;

      // Get first 3 collaborators
      const collaborators = creator.collaborators?.slice(0, 3).map((collab) => ({
        name: collab.name || '',
        avatarUrl: collab.avatarUrl || '',
      })) || [];

      return {
        'Creator Name': creator.name || '',
        Username: creator.username || '',
        'Location Name': creator.location?.name || '',
        'Avatar URL': creator.avatarUrl || '',
        'Collaborator 1 Name': collaborators[0]?.name || '',
        'Collaborator 1 Avatar URL': collaborators[0]?.avatarUrl || '',
        'Collaborator 2 Name': collaborators[1]?.name || '',
        'Collaborator 2 Avatar URL': collaborators[1]?.avatarUrl || '',
        'Collaborator 3 Name': collaborators[2]?.name || '',
        'Collaborator 3 Avatar URL': collaborators[2]?.avatarUrl || '',
        Likes: creator.likes || 0,
        Views: creator.views || 0,
        'Total Followers': totalFollowers,
        'Instagram Account': instagramAccount,
        'Twitter Account': twitterAccount,
      };
    });

    // Convert to CSV
    const headers = Object.keys(csvData[0]);
    const csvContent = [
      headers.join(','),
      ...csvData.map((row) => headers.map((header) => {
        const value = row[header as keyof typeof row];
        // Escape commas and quotes in CSV values
        if (typeof value === 'string' && (value.includes(',') || value.includes('"'))) {
          return `"${value.replace(/"/g, '""')}"`;
        }
        return value;
      }).join(',')),
    ].join('\n');

    // Create and download file
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `creators-export-${new Date().toISOString().split('T')[0]}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  if (!creators?.length) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={exportToCSV}
      className="btn-primary-outlined-xs"
      title="Export creators to CSV"
    >
      <div className="flex items-center uppercase">
        <FileDownload fontSize="small" className="mr-1" />
        CSV
      </div>
    </button>
  );
};
